<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/position/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zhiweibianhao')">
            <el-input v-model="yt.conditions.posNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhiweimingcheng')">
            <el-input v-model="yt.conditions.posName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1');" type="primary" v-if="utils.checkPower('web_employment_management_position_add_button')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_position_update_button')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_position_delete_button')">
            <el-popconfirm title="是否确认删除职位？删除后可能造成基础数据缺失" confirm-button-text="是" cancelButtonText="否" @confirm="deleteRecord(scope.row)">
              <el-button type="text" class="font-color-danger" slot="reference" :loading="loading">{{ $t('shanchu') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng'||yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zhiweibianhao')" required>
            <el-input v-model="yt.editObj.posNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhiweimingcheng')" required>
            <el-input v-model="yt.editObj.posName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false;">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/position/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/position/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "web_employment_management_position_list",
  data() {
    return {
      loading:false,
      columns: [
        {
          label: 'zhiweibianhao',
          prop: 'posNo'
        },
        {
          label: 'zhiweimingcheng',
          prop: 'posName'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    deleteRecord(data) {
      this.loading = true;
      this.http.post('web/position/delete', data).then(res => {
        this.$message({
          message: this.$t('success'),
          type: 'success'
        });
        this.yt.get();
      }).catch(error => {
        this.$message.error(this.$t(error));
      }).finally(()=>{
        this.loading = false;
      });
    },
  },
}
</script>

<style scoped>

</style>